/**
 * Expédition A2 — parse GET /expedition/profiles → options select ProduitModal.
 * Contrat API canonique : { items: ShippingProfile[] }
 */

/**
 * @param {unknown} res — corps JSON de listExpeditionProfiles
 * @returns {Array<{ id: string, name?: string, isActive?: boolean }>}
 */
export function parseExpeditionProfilesResponse(res) {
  return Array.isArray(res?.items) ? res.items : [];
}

/**
 * Tri aligné API : actifs d'abord, puis nom (locale fr).
 * @param {Array<{ id: string, name?: string, isActive?: boolean }>} profiles
 */
export function sortExpeditionProfilesForSelect(profiles) {
  return [...(profiles || [])].sort((a, b) => {
    if (Boolean(a?.isActive) !== Boolean(b?.isActive)) {
      return a?.isActive ? -1 : 1;
    }
    return String(a?.name || '').localeCompare(String(b?.name || ''), 'fr');
  });
}

/**
 * Options du select « Profil colis » (valeur + libellé).
 * Toujours préfixe « Non expédiable » (value '').
 * @param {Array<{ id: string, name?: string, isActive?: boolean }>} profiles
 * @returns {Array<{ value: string, label: string }>}
 */
export function buildExpeditionProfileSelectOptions(profiles) {
  const sorted = sortExpeditionProfilesForSelect(profiles);
  return [
    { value: '', label: 'Non expédiable' },
    ...sorted.map((profile) => ({
      value: String(profile.id),
      label:
        profile.isActive === false
          ? `${profile.name || profile.id} (Inactif)`
          : String(profile.name || profile.id),
    })),
  ];
}
